import { render, staticRenderFns } from "./DescriptionCardNew.vue?vue&type=template&id=31b6283e&"
import script from "./DescriptionCardNew.vue?vue&type=script&lang=js&"
export * from "./DescriptionCardNew.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCardNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports